<template>
  <v-row class="justify-center">
    <v-col cols="12" sm="6" md="4">
      <!-- IMAGE -->
      <viewer
        :images="[content]"
        :options="viewerOptions"
        class="viewer-container-class"
      >
        <img
          v-if="item.imgNo"
          :src="content"
          class="fit-image"
        />
      </viewer>

      <!-- FILE BUTTON -->
      <div class="d-flex flex-row mt-2">
        <v-btn
          v-if="item.cntImgDsn"
          x-small
          color="primary"
          @click="$emit('open-file', item, 'R')"
        >
          Design: {{ item.cntImgDsn }}
        </v-btn>

        <v-btn
          v-if="item.cntImgQm"
          x-small
          color="primary"
          class="ml-2"
          @click="$emit('open-file', item, 'C')"
        >
          QM: {{ item.cntImgQm }}
        </v-btn>

        <v-btn
          v-if="item.cntImgPro"
          x-small
          color="primary"
          class="ml-2"
          @click="$emit('open-file', item, 'A')"
        >
          Prod: {{ item.cntImgPro }}
        </v-btn>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    item: Object,
    content: String,
    viewerOptions: Object
  }
}
</script>